function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 15c.4 0 .8-.3.8-.8v-9c0-.4-.3-.8-.8-.8s-.8.3-.8.8v9c0 .5.4.8.8.8zm4.5 0c.4 0 .8-.3.8-.8V7.5c0-.4-.3-.8-.8-.8s-.8.3-.8.8v6.8c.1.4.4.7.8.7zm-9 0c.4 0 .8-.3.8-.8v-3c0-.4-.3-.8-.8-.8s-.8.3-.8.8v3c.1.5.4.8.8.8zM0 0v1.5h1.5v14.2c0 1.8 1.2 3 3 3H9L6 24h2.3l3-5.2h1.5l3 5.2h2.3l-3-5.2h4.5c1.8 0 3-1.2 3-3V1.6H24V0H0zm21 15.8c0 .9-.6 1.5-1.5 1.5h-15c-.9 0-1.5-.6-1.5-1.5V1.5h18v14.3z"
});

function SvgAnalyticsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgAnalyticsIcon;